import { createMandatoryContext } from '@change-corgi/core/react/context';

import type { UserInfo } from 'src/app/pages/petition/shared/tabTypes';

export type PetitionDetailsPageUserInfo = UserInfo;

export const {
	Context: PetitionDetailsPageUserInfoContext,
	Provider: PetitionDetailsPageUserInfoContextProvider,
	useContext: usePetitionDetailsPageUserInfo,
} = createMandatoryContext<PetitionDetailsPageUserInfo | undefined, { userInfo: UserInfo }>(undefined, {
	name: 'PetitionDetailsPageUserInfoContext',
	processProviderProps: ({ userInfo }) => userInfo,
});
